var map = {
	"./back-office/icon-content-active.svg": 563,
	"./back-office/icon-content.svg": 564,
	"./back-office/icon-delete-red.svg": 565,
	"./back-office/icon-document-active.svg": 566,
	"./back-office/icon-document.svg": 567,
	"./back-office/icon-download-gray.svg": 568,
	"./back-office/icon-download-primary.svg": 569,
	"./back-office/icon-history-active.svg": 570,
	"./back-office/icon-history.svg": 571,
	"./back-office/icon-master-data-active.svg": 572,
	"./back-office/icon-master-data.svg": 573,
	"./back-office/icon-pencil-edit-active.svg": 574,
	"./back-office/icon-pencil-edit.svg": 575,
	"./back-office/icon-qa-active.svg": 576,
	"./back-office/icon-qa.svg": 577,
	"./back-office/icon-self-assessment-active.svg": 578,
	"./back-office/icon-self-assessment.svg": 579,
	"./back-office/icon-upload-arrow.svg": 580,
	"./back-office/icon-upload.svg": 581,
	"./back-office/icon-user-access-active.svg": 582,
	"./back-office/icon-user-access.svg": 583,
	"./back-office/icon-user-active.svg": 584,
	"./back-office/icon-user.svg": 585,
	"./back-office/icon-users-active.svg": 586,
	"./back-office/icon-users.svg": 587,
	"./chat-active.png": 588,
	"./check-active.png": 589,
	"./check.png": 590,
	"./chevron-left.png": 591,
	"./close.png": 592,
	"./download-active.png": 593,
	"./edit-report.png": 594,
	"./eye-active.png": 595,
	"./folder.png": 596,
	"./icon-chevron-left-blue.svg": 597,
	"./icon-chevron-left.svg": 598,
	"./icon-close.svg": 599,
	"./icon-config-filled.svg": 600,
	"./icon-facebook-filled.svg": 601,
	"./icon-facebook.svg": 602,
	"./icon-hamburger.svg": 603,
	"./icon-success.svg": 604,
	"./icon-triple-dot.svg": 605,
	"./icon-twitter-filled.svg": 606,
	"./icon-twitter.svg": 607,
	"./icon-user-empty.svg": 608
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 562;